import { useMutation } from "react-query";
import { CreateVacation } from "services/workSchedule";

export default function UseCreateVacation() {
  return useMutation(
    (data:any) => CreateVacation(data),
  );
}